import { buildForm, Button, Form, SubmitButton } from "@bleu.builders/ui";
import Card from "@components/ui/Card";
import Dialog, { useDialog } from "@components/ui/Dialog";
import { useProgram } from "@contexts/ProgramContext";
import { DownloadIcon } from "@radix-ui/react-icons";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

const getFields = (profileAttributes, modeValue) => {
  const baseFields = [
    {
      name: "mode",
      label: "Mode",
      type: "radio_item",
      tooltip:
        "Default is recommended for programs with more then 10,000 users. If your program have more then please contact support.",
      layout: "stack",
      options: [
        { label: "Default", value: "default" },
        { label: "Detailed", value: "detailed" },
      ],
    },
  ];

  if (modeValue === "detailed" && profileAttributes) {
    const attributeOptions = Object.keys(profileAttributes).map((key) => {
      const attributeName = profileAttributes[key];
      return {
        label: attributeName.display_name,
        value: attributeName.attribute_name,
      };
    });

    const multiSelectField = {
      name: "selected_attributes",
      label: "Selected Attributes",
      type: "multi_select_checkbox",
      tooltip: "Select attributes to include in the report",
      options: attributeOptions,
    };

    return [...baseFields, multiSelectField];
  }

  return baseFields;
};

export function ExportCsvForm() {
  const program = useProgram();
  const [wasSubmitted, setWasSubmitted] = React.useState(false);
  const form = useForm({
    defaultValues: {
      mode: "default",
      selected_attributes: [],
    },
  });
  // @ts-expect-error TS(2339) FIXME: Property 'close' does not exist on type '{}'.
  const { close } = useDialog();
  const { program_id } = useParams();

  const mode = form.getValues("mode");
  const FIELDS = getFields(program.active_profile_attributes, mode);

  useEffect(() => {
    if (wasSubmitted) {
      close();
      setWasSubmitted(false);
    }
  }, [close, wasSubmitted]);

  const handleSubmit = async () => {
    try {
      const selected_attributes = form.getValues("selected_attributes");

      const params = new URLSearchParams();
      params.append("mode", mode);

      if (selected_attributes && selected_attributes.length > 0) {
        selected_attributes.forEach((attribute) => {
          params.append("selected_attributes[]", attribute);
        });
      }
      const downloadUrl = `/admin/v2/programs/${program_id}/participants.csv?${params.toString()}`;

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `program-${program_id}-participants.csv`);
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      setWasSubmitted(true);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Card.Root className="max-w-none bg-background max-h-[740px] overflow-y-auto">
      <Card.Header>
        <Card.Title className="pl-2 text-xl">Export Users</Card.Title>
        <Card.Description className="py-0 text-sm">
          Export users from your Program to a CSV file.
        </Card.Description>
      </Card.Header>
      <Card.Content className="mx-4 gap-10">
        <Form className="flex flex-col gap-4 w-full" {...form}>
          <div className="grid grid-cols-2 gap-2">
            {/* @ts-expect-error TS(2322) FIXME: Type '{ children: Element; className: string; }' i... Remove this comment to see the full error message */}
            {buildForm(FIELDS, form)}
          </div>
          <SubmitButton type="button" onClick={handleSubmit}>
            Export
          </SubmitButton>
        </Form>
      </Card.Content>
    </Card.Root>
  );
}

export function ExportCsvDialog({ defaultOpen = true }) {
  return (
    //  @ts-expect-error TS(2322) FIXME: Type '{ children: Element; className: string; }' i... Remove this comment to see the full error message
    <Dialog.Root defaultOpen={defaultOpen} className="max-w-none">
      <Dialog.Trigger asChild>
        <Button size="sm" className="ml-auto hidden h-8 lg:flex">
          <DownloadIcon className="mr-2 size-4" />
          <span>Export Table</span>
        </Button>
      </Dialog.Trigger>
      <Dialog.Content className="sm:max-w-[1000px] max-w-none">
        <ExportCsvForm />
      </Dialog.Content>
    </Dialog.Root>
  );
}
